var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-indicator",class:{ 'listening': _vm.isListening }},[_c('i',{staticClass:"fas fa-microphone"}),_c('span',[_vm._v(_vm._s(_vm.isListening ? 'Listening...' : 'Processing...'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }